import axiosClient from "./axiosClient";


export const getReservations = async (store_id, channel_id, start_date, end_date) => {
    try {
        const url = `/stores/${store_id}/channels/${channel_id}/reservations`;
        console.log('[getReservations] URL:', url, '| params:', { start_date, end_date });
        const response = await axiosClient.get(url, {
            params: { start_date, end_date },
            withCredentials: true,
        });
        console.log('[getReservations] response:', response.data);
        return response.data;
    } catch (error) {
        console.error("예약 데이터 로드 중 에러 발생:", error);
        throw error;
    }
};